import React, { useState, useEffect } from "react";
import { useLang } from "@/i18n";
import { updateGoogleConsent } from "@/components/GoogleTag";

export const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("atlas_cookie_consent")) {
      const tm = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(tm);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem("atlas_cookie_consent", value);
    updateGoogleConsent(value === "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[100] atlas-fade-up">
      <div className="mx-auto max-w-7xl m-0 md:m-4 bg-white border border-[#E5E0D8] shadow-[0_8px_32px_rgba(0,0,0,0.14)] md:rounded-sm p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex-1">
          <h3 className="font-display text-2xl text-[#2A3324] mb-1">{t("cookie_title")}</h3>
          <p className="text-sm text-[#5C6656] leading-relaxed max-w-2xl">{t("cookie_text")}</p>
        </div>
        <div className="flex flex-wrap gap-3 shrink-0">
          <button data-testid="cookie-decline-btn" onClick={() => decide("declined")}
            className="px-5 py-3 text-sm font-semibold border border-[#E5E0D8] text-[#2A3324] hover:bg-[#F0EBE1] transition-colors rounded-sm">
            {t("cookie_decline")}
          </button>
          <button data-testid="cookie-accept-btn" onClick={() => decide("accepted")}
            className="px-6 py-3 text-sm font-semibold bg-[#C05C3B] hover:bg-[#A64D30] text-white transition-colors rounded-sm">
            {t("cookie_accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
